<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="letteraDiffidaForm">
<form [formGroup]="letteraDiffidaForm" (ngSubmit)="update();">
	<div class="row">

		<div comboModInput [control]="letteraDiffidaForm.controls['tipoLettera']"
			class="col-sm-3 obbligatorio" [labelInput]="'Tipo lettera'"
			formControlName="tipoLettera" [mandatory]="true"
			[objectReference]="request.tipoLettera"
			(onReturn)="request.tipoLettera = $event"
			[optionsCombo] ="tipiLetteraDiffida" [ngModel]="request.tipoLettera"></div>

		<div datePickerInput class="col-sm-3 obbligatorio"
			[labelInput]="'Data'" formControlName="dataLettera"
			[(ngModel)]="request.dataLettera" [mandatory]="true"
			[control]="letteraDiffidaForm.controls['dataLettera']"></div>

		<div textInput [control]="letteraDiffidaForm.controls['mittente']"
			class="col-sm-3" [labelInput]="'Mittente'"
			formControlName="mittente" [(ngModel)]="request.mittente"></div>

		<div comboModInput
			class="col-sm-3 obbligatorio" [labelInput]="'Destinatario'"
			formControlName="destinatario"
			[labelOption]="'parte.nominativo'"
			[labelOptionSeparator]="' '" [control]="letteraDiffidaForm.controls['destinatario']"
			[objectReference]="request.destinatario"
			(onReturn)="request.destinatario = $event"
			[optionsCombo] ="destinatari" [ngModel]="request.destinatario"></div>
	</div>
	<div class="row">
		<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
			formControlName="note" [(ngModel)]="request.note"></div>
	</div>
	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
		</p>
		<p submitButton
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[disabled]="!letteraDiffidaForm.valid"
			[labelButton]="'Inserisci e salva'">
	</div>
</form>
</ng-template>
